module.exports = __webpack_public_path__ + "static/media/reddit-social-media-svgrepo-com (1).7a183ce8.svg";